
import axios from 'axios'
const prod = "https://www.maisons-cognac.fr";
//const prod = "https://smc.lba-digital.fr";
const apiClient = axios.create({
  baseURL: prod  + '/wp-json/smc/v1/',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
})

export default apiClient;